import state from "./state";
export default {
  SELECTED_CAMPAIGN(state, payload) {
    console.log(payload, "mutat");
    state.selectedCampaign = payload;
  },
  CAMPAIGN(state, payload) {
    console.log(payload, "mutat");
    state.campaign = payload;
  },
};
